import type { FeatureFlags } from "../../../logic/featureFlags/featureFlagsServices";
import { featureFlagsVar, userDataVar } from "../../model";


export const getFeatureFlags = () => featureFlagsVar();
export const setFeatureFlags = (featureFlags: FeatureFlags) => featureFlagsVar(featureFlags);

export const getUserData = () => userDataVar();
